import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=05d886a0&scoped=true&lang=html&"
import script from "./Offer.vue?vue&type=script&lang=js&"
export * from "./Offer.vue?vue&type=script&lang=js&"
import style0 from "./Offer.vue?vue&type=style&index=0&id=05d886a0&prod&lang=css&"
import style1 from "./Offer.vue?vue&type=style&index=1&id=05d886a0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d886a0",
  null
  
)

export default component.exports